import React from "react";

// Stub. t5 (Data Catalog) has no document-revision feature, but the shared Platform*
// component family (PlatformLongSelect -> here) carries a dormant import of this applet.
// This placeholder satisfies that import so PlatformTable/PlatformDetail compile in t5; the
// render branch that would mount it (a document-revision long-select) is never reached.
class DocumentRevisionTableApplet extends React.Component {
    render() {
        return null;
    }
}

export default DocumentRevisionTableApplet;
